import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "migrate-customers",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const migrateCustomers = require("./MigrateCustomers").default;
          cb(null, migrateCustomers);
        },
        "MigrateCustomers"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/MigrateCustomers/index.js